import { IPartnerFlag, IPartnerFlags } from 'clickNgo/entities/partner/models/partnerFlag'
import { ProfilingCodeType } from 'clickNgo/entities/profilingCode'
import { ICrudFetchOptions } from 'clickNgo/models/crud/utils'

import { fetchPartnerFlagsByIdAndType } from './fetchPartnerFlagsByIdAndType'
import { fetchPartnerFlagsRequestsByIdAndType } from './fetchPartnerFlagsRequestsByIdAndType'

export const mergePartnerFlags = (
  master: IPartnerFlag[],
  request: IPartnerFlag[]
): IPartnerFlags => {
  const filteredMasterData = master.filter(
    (masterFlag) => !request.find((requestFlag) => requestFlag.code === masterFlag.code)
  )

  const flags = [...request, ...filteredMasterData]

  const accreditation = flags.filter(({ codeType }) => codeType === ProfilingCodeType.Accreditation)
  const program = flags.filter(({ codeType }) => codeType === ProfilingCodeType.Program)
  const agreement = flags.filter(({ codeType }) => codeType === ProfilingCodeType.Agreement)

  return {
    accreditation,
    program,
    agreement,
  }
}

export const fetchPartnerFlagsById = async (
  partnerId: string,
  options?: ICrudFetchOptions
): Promise<IPartnerFlags> => {
  const params = { partnerId }
  const cacheKey = options?.cacheKey || partnerId
  const master = await fetchPartnerFlagsByIdAndType(params, { ...options, cacheKey })
  const request = await fetchPartnerFlagsRequestsByIdAndType(params, { ...options, cacheKey })

  return mergePartnerFlags(master, request)
}
